module.exports = __webpack_public_path__ + "img/xray-with-http-call.384b7dc3.png";